import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-restaurants',
  templateUrl: './restaurants.component.html',
  styles: [
  ]
})
export class RestaurantsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
